import { t } from 'ttag';

import { validatePassword } from '../../../../lib/helpers';

import { EMAIL_PATTERN } from '../../../../lib/constants';

interface PasswordRules {
    minLength: number;
}

const customDomainPasswordRules: Record<string, PasswordRules> = {
    'ua.nestle.com': {
        minLength: 16,
    },
    'ua.bosch.com': {
        minLength: 12,
    },
    'boschrexroth.com.ua': {
        minLength: 12,
    },
    'bosch.com': {
        minLength: 12,
    },
};

const defaultPasswordRules: PasswordRules = {
    minLength: 8,
};

export const getPasswordRuleByEmail = (email = ''): PasswordRules => {
    if (!email) {
        return defaultPasswordRules;
    }

    const key = Object.keys(customDomainPasswordRules).find((domain) =>
        email.endsWith(domain),
    );

    return key ? customDomainPasswordRules[key] : defaultPasswordRules;
};

type FieldKey = 'email' | 'password' | 'phone' | 'username';

export const validate = (fields: Partial<Record<FieldKey, string>>) => {
    const errors: Partial<Record<FieldKey, string>> = {};

    if (!fields.email) {
        errors.email = t`Обов'язкове поле`;
    } else if (!EMAIL_PATTERN.test(fields.email.trim())) {
        errors.email = t`Перевірте правильність написання email`;
    }

    if (!fields.password) {
        errors.password = t`Обов'язкове поле`;
    } else {
        const passwordErrorMessage = validatePassword(
            fields.password,
            getPasswordRuleByEmail(fields.email),
        );
        if (passwordErrorMessage) {
            errors.password = passwordErrorMessage;
        }
    }

    if (!fields.phone) {
        errors.phone = t`Обов'язкове поле`;
    }

    return errors;
};
